import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';

const PageLoader = () => (
  <div
    className="flex items-center justify-center min-h-screen"
    style={{ backgroundColor: 'var(--color-background)' }}
  >
    <div className="flex flex-col items-center gap-3">
      <div
        className="w-8 h-8 rounded-full border-2 border-t-transparent animate-spin"
        style={{ borderColor: 'var(--color-secondary)', borderTopColor: 'transparent' }}
      />
      <p className="text-sm" style={{ color: 'var(--color-muted-foreground)' }}>
        Loading…
      </p>
    </div>
  </div>
);

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <PageLoader />;

  if (!user) {
    return <Navigate to="/registration-login" state={{ from: location }} replace />;
  }

  return children;
}
